// @format

import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import VisibilitySensor from 'react-visibility-sensor';
import { withStateHandlers } from 'recompose';

import phoneContent from './page3image2.png';
import phoneContentMobile from './page3image2-mobile.png';
import messageContent from './page3image3.png';
import messageContentMobile from './page3image3-mobile.png';
import PhoneWithPhoto from 'modules/components/PhoneWithPhoto';
import MatchMedia from 'modules/components/MatchMedia';

import './MessageIntro.css';

const MessageIntro = ({
  className,
  isPhoneContentVisible,
  setIsPhoneContentVisible,
}) => (
  <section className={classnames('MessageIntro', className)}>
    <div className="MessageIntro-profile">
      <p className="MessageIntro-profile-left">Profile and Message</p>
      <MatchMedia mediaQueries="(min-width: 1149px)">
        {isMatched => (
          <VisibilitySensor
            partialVisibility={true}
            offset={{ top: 200 }}
            onChange={setIsPhoneContentVisible}
          >
            {({ isVisible }) => (
              <PhoneWithPhoto
                className={classnames('MessageIntro-phone', {
                  'element-enter': isVisible,
                })}
              >
                <img
                  className="PhoneWithPhoto-content-bg animate-main"
                  src={isMatched ? phoneContent : phoneContentMobile}
                  alt="phone content"
                />
                <img
                  className="PhoneWithPhoto-content-bg animate-slave"
                  src={isMatched ? messageContent : messageContentMobile}
                  alt="phone content"
                />
              </PhoneWithPhoto>
            )}
          </VisibilitySensor>
        )}
      </MatchMedia>
      <p
        className={classnames('MessageIntro-profile-right', {
          'element-enter': isPhoneContentVisible,
        })}
      >
        <span className="MessageIntro-profile-right-main">
          Personal profile is the best way to promote yourself. Enrich your
          profile with other social accounts.
        </span>
        <span className="MessageIntro-profile-right-slave">
          Direct contact with someone you’re interested in.
        </span>
      </p>
    </div>
  </section>
);

MessageIntro.propType = {
  className: PropTypes.string,
  isPhoneContentVisible: PropTypes.bool,
  setIsPhoneContentVisible: PropTypes.func,
};

export default withStateHandlers(
  { isPhoneContentVisible: false },
  {
    setIsPhoneContentVisible: () => value => ({
      isPhoneContentVisible: value,
    }),
  },
)(MessageIntro);



// WEBPACK FOOTER //
// ./src/modules/components/MessageIntro/MessageIntro.js